import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// A questionnaire's questions by what grading made of their answers, in its
// answer view. The options (with counts) come from the questions on the page.
export const QuestionJudgmentFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTION_JUDGMENT}
      filterName={FilterName.QUESTION_JUDGMENT}
      valueKey="questionJudgments"
      isNested={isNested}
    />
  ),
)
